import { StepDef, TestDef } from "../models.js";
import { getBlindMoveSetup } from "./commonSteps.js";
import cc_widgets from '../configChecker_widgets.js';
import immediateApi from "../../../api/immediateApi";

import * as cc_helpers from "../configChecker_helpers";
import { getMlConfig } from '../configState.js';


function getExitSequence(chooseMoveDirection) {
  const exitSequence = new StepDef( ({actuator, diagnose, pass, runtime, notifier}) => {
    cc_widgets.StepWidgets.askChoice({ title: `Did the actuator move towards the ${ runtime.ctx.jog > 0 ? "end" : "home"} sensor?`, group: true, tooltips: [{category: 'sensor'}] }, ["Yes", "No", "Not sure, retry"], (answer) => {
      if(answer === 'Yes') {
        actuator.directionValidatable.isValid = true;
        pass(`The configured direction is correct.`);
        notifier.finished();
      } else if (answer === "No") {
        runtime.runStep(AutoFixInfo);
      } else {
        runtime.runStep(chooseMoveDirection);
      }
    });
  });

  const AutoFixInfo = new StepDef(({ actuator, runtime, fail }) => {
    const lAxisConfigObj = getMlConfig().getAxisByUuid(actuator.parameters.uuid);
    const lInfoWidget = new cc_widgets.InfoWidget();
    const consentUI = cc_widgets.StepWidgets.consentMove(
      {
        title: _ => `The Configuration Checker will swap the direction of your actuator.`,
      }, () => {
        consentUI.addWidget(lInfoWidget);
        lInfoWidget.update('Updating config...', true);

        lAxisConfigObj.invertRotation();

        actuator.parameters.rotation = lAxisConfigObj.mRotation;

        lAxisConfigObj.mChildrenDrives.forEach((child, index) => {
          actuator.children[index].rotation = child.rotation;
        });

        immediateApi.getSmartDriveStatus(actuator.parameters.controllerId)
          .then(() => {
            cc_helpers.updateEndStopPorts(actuator, undefined, () => { runtime.runStep(fixedDirection); });
          }).catch(cc_helpers.configCheckerOnErrorCallback);
      });
  });

  const fixedDirection = new StepDef( ({autofix, notifier}) => {
    autofix({
      message: `The direction of your actuator has been fixed.`,
      category: 'direction'
    });
    notifier.finished();
  });
  return exitSequence;
}


export default new TestDef({
  info: {
    friendlyName: "Verify the motion direction",
    precedence: 2,
    desc: 'To verify that the configured direction of the actuator corresponds to the end-of-travel sensor you chose the home position to be, we will try to move the actuator towards one of its end-of-travel sensors.',
  },
  entryStep: getBlindMoveSetup('direction', getExitSequence),
  validatesOnSuccess: (actuator) => actuator.directionValidatable,
});
